import React, { useState } from "react";
import { UsersIcon } from "@heroicons/react/solid";
import {
  testimonials,
  TRUSTPILOT_PROFILE_URL,
  TRUSTPILOT_REVIEW_URL,
} from "../data";
import ReviewModal from "./ReviewModal";

export default function Testimonials() {
  const [showReviewModal, setShowReviewModal] = useState(false);

  return (
    <section id="testimonials" className="bg-white text-gray-900">
      <div className="container px-5 py-16 mx-auto max-w-6xl text-center">
        <div className="flex justify-center">
          <UsersIcon className="w-10 text-purple-600 inline-block mb-4" />
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold title-font text-gray-900 mb-4">
          Client Testimonials
        </h1>
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          <button
            onClick={() => setShowReviewModal(true)}
            className="text-white bg-purple-600 border-0 py-2 px-6 focus:outline-none hover:bg-purple-700 rounded-full text-sm"
          >
            Leave a Review
          </button>
          <a
            href={TRUSTPILOT_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-purple-600 bg-white border border-purple-300 py-2 px-6 hover:bg-purple-50 rounded-full text-sm"
          >
            Review us on Trustpilot
          </a>
          <a
            href={TRUSTPILOT_PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-purple-600 bg-white border border-purple-300 py-2 px-6 hover:bg-purple-50 rounded-full text-sm"
          >
            See our reviews
          </a>
        </div>
        <div className="flex flex-wrap -m-2">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="p-2 sm:w-1/2 md:w-1/3 lg:w-1/4 w-full">
              <div className="h-full bg-purple-50 border border-purple-100 p-6 rounded-xl shadow-sm">
                <p className="leading-relaxed text-gray-700 text-sm mb-4">
                  {testimonial.quote}
                </p>
                <div className="inline-flex items-center">
                  <img
                    alt="testimonial"
                    src={testimonial.image}
                    className="w-10 h-10 rounded-full flex-shrink-0 object-cover object-center border border-purple-200"
                  />
                  <span className="flex-grow flex flex-col pl-3">
                    <span className="title-font font-medium text-gray-900 text-sm">
                      {testimonial.name}
                    </span>
                    <span className="text-purple-600 text-xs uppercase">
                      {testimonial.company}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {showReviewModal && (
        <ReviewModal onClose={() => setShowReviewModal(false)} />
      )}
    </section>
  );
}
